<template>
    <div>
        <viewer
            :images="images"
            :options="options"
            class="viewer"
            ref="viewer"
            @inited="inited"
            v-if="images && images.length"
        >
            <img
                v-for="{ source, thumbnail } in images"
                :src="thumbnail"
                :data-source="source"
                :key="source"
                class="image"
            />
        </viewer>
    </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import { component as viewer } from 'v-viewer'
export default {
    components: { viewer },
    props: {
        singlePhoto: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            options: {
                url: 'data-source'
            },
            index: 0,
            images: []
        }
    },
    methods: {
        inited(viewer) {
            this.$viewer = viewer
            this.$viewer.view(this.index)
        },
        view(index) {
            this.index = index
            this.$viewer.view(this.index)
        },
        show(images, index = 0) {
            if (this.images === images) {
                this.view(index)
                return
            }
            this.images = images
            this.index = index
        }
    }
}
</script>

<style lang="scss" scoped>
.image {
  display: none;
}
</style>
<style lang="scss">
.viewer-loading > img {
  display: none; /* hide big images when it is loading */
}
</style>